import { walletRepository } from '@/repositories/Index'

class VirtualCurrencyService {
	async getCpsAccountInfo() {
		const res = await walletRepository.getCpsAccountInfo()
		return res
	}
	async saveConfig(params: any) {
		const res = await walletRepository.saveConfig(params)
		return res
	}
	async updateConfig(params: any) {
		const res = await walletRepository.updateConfig(params)
		return res
	}
	async checkReservedPhoneNumber(params: any) {
		const res = await walletRepository.checkReservedPhoneNumber(params)
		return res
	}
	async getFipSaleRoomDetail(params: any) {
		const res = await walletRepository.getFipSaleRoomDetail(params)
		return res
	}
	async querySaleRoomConfigStatus() {
		const res = await walletRepository.querySaleRoomConfigStatus()
		return res
	}

	async saveMerchantMobileWhitelist(params: any) {
		const res = await walletRepository.saveMerchantMobileWhitelist(params)
		return res
	}
	async queryMerchantMobileWhitelist() {
		const res = await walletRepository.queryMerchantMobileWhitelist()
		return res
	}

	async getDiagnosisInfo() {
		const res = await walletRepository.getDiagnosisInfo()
		return res
	}
	async logQuery(params: any) {
		const res = await walletRepository.query(params)
		return res
	}

	async getWalletInfo(params: any) {
		const res = await walletRepository.getWalletInfo(params)
		return res
	}

	async getRechargeRedPacketList(params: any) {
		const res = await walletRepository.getRechargeRedPacketList(params)
		return res
	}

	async getUseRedPacket(params: any) {
		const res = await walletRepository.getUseRedPacket(params)
		return res
	}

	async toPayment(params: any) {
		const res = await walletRepository.toPayment(params)
		return res
	}

	async getPaymentPage(params: any) {
		const res = await walletRepository.getPaymentPage(params)
		return res
	}

	async getPopStatus(params: any) {
		const res = await walletRepository.getPopStatus(params)
		return res
	}

	async redPacketTransList(params: any) {
		const res = await walletRepository.redPacketTransList(params)
		return res
	}

	async getRechargeList(params: any) {
		const res = await walletRepository.getRechargeList(params)
		return res
	}

	async getConsumeList(params: any) {
		const res = await walletRepository.getConsumeList(params)
		return res
	}

	async getRedPackConsumeList(params: any) {
		const res = await walletRepository.getRedPackConsumeList(params)
		return res
	}

	async getSmsMarketMessageLogs(params: any) {
		const res = await walletRepository.getSmsMarketMessageLogs(params)
		return res
	}

	async accountTradeCancel(params: any) {
		const res = await walletRepository.accountTradeCancel(params)
		return res
	}

	async cpsPopout(params: any) {
		const res = await walletRepository.cpsPopout(params)
		return res
	}

	async calculateRechargePrice(params: any) {
		const res = await walletRepository.calculateRechargePrice(params)
		return res
	}

	async getPaymentOrderList(params: any) {
		const res = await walletRepository.getPaymentOrderList(params)
		return res
	}

	async otaPayment(params: any) {
		const res = await walletRepository.otaPayment(params)
		return res
	}

	async cancelPayOrder(params: any) {
		const res = await walletRepository.cancelPayOrder(params)
		return res
	}

	async existOtaContract() {
		const res = await walletRepository.existOtaContract()
		return res
	}
}

export default VirtualCurrencyService
